import platform from './node/index.js';

export {platform as default}



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 45
// module chunks = 14